export default {
    autenticacao: JSON.parse(localStorage.getItem('autenticacao')) || null,
    centroCusto: JSON.parse(localStorage.getItem('centro_custo')) || {},
    cliente: JSON.parse(localStorage.getItem('cliente') || null),
    customer: JSON.parse(localStorage.getItem('customer')) || null,
    exportacaoBpaEmAndamento: localStorage.getItem('exportacao_bpa_em_andamento') === 'true' ? true : false,
    exportacaoEsusEmAndamento: localStorage.getItem('exportacao_esus_em_andamento') === 'true' ? true : false,
    fila: JSON.parse(localStorage.getItem('fila')),
    loading: 0,
    lotacao: JSON.parse(localStorage.getItem('lotacao')) || {},
    menu: JSON.parse(localStorage.getItem('menu')) || null,
    quantidadeNotasVersaoNovas: localStorage.getItem('quantidade_notas_versao_novas') || 0,
    quantidadeNotificacoesNaoLidas: localStorage.getItem('quantidade_notificacoes_nao_lidas') || 0,
    routerInfo: null,
    showExitFormConfirmation: false,
    sidebar: localStorage.getItem('sidebar') === 'true' ? true : false,
}